import { Stack, Typography, Link } from "@mui/material";
import React from "react";

type Props = {};

const Privacy = (props: Props) => {
  return (
    <Stack 
      direction="column" 
      alignItems="flex-start" 
      p={2} 
      spacing={3}
      sx={{ maxWidth: 1100, margin: "0 auto", lineHeight: 1.7 }}
    >
      <Typography variant="h5" fontWeight="bold" textAlign="left">
        Privacy Policy
      </Typography>
      
      <Typography variant="body1" textAlign="justify">
        Modern College of Physiotherapy respects your right to privacy. When you
        visit the official website of Modern College of Physiotherapy (
        <Link 
          href="http://www.mcopt.ac.in/" 
          target="_blank" 
          underline="hover"
          sx={{
            color: 'primary.main',
            "&:hover": {
              color: "secondary.main",
            },
          }}
        >
          www.mcopt.ac.in
        </Link>
        ), the following information may be collected from you, either
        voluntarily or involuntarily: your computer or network’s IP address,
        your email address and message when you communicate electronically with
        us, and information about your visit gathered in an aggregate manner for
        quality control, security, and improvement of our website.
      </Typography>

      <Typography variant="body1" textAlign="justify">
        Your information is kept confidential, unaltered, and used only by
        Modern College of Physiotherapy to administer your request. Modern
        College of Physiotherapy does not disclose or sell any personally
        identifiable information collected on this website to other companies or
        organizations.
      </Typography>
    </Stack>
  );
};

export default Privacy;
